import { Box, Button, styledComponent, Theme } from '@hermes/web-components'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { MobileDetailsModal } from '../MobileDetailsModal'
import { TEST_IDS } from '../../../__tests__/testUtils/constants'

interface MobileFilterDetailsModalProps {
  isOpen: boolean
  onClose: () => void
  renderSearchFilters: (...p: any) => JSX.Element
}

const StyledButton = styledComponent(Button)(({ theme }: { theme: Theme }) => ({
  ...(theme?.custom?.SearchFilters?.button ?? {}),
  color: theme.palette.common.white
}))

const MobileFilterDetailsModal = ({ isOpen, onClose, renderSearchFilters }: MobileFilterDetailsModalProps) => {
  const translate = useTranslateMessage()

  if (!isOpen) {
    return null
  }
  return (
    <MobileDetailsModal isOpen={isOpen} onClose={onClose} heading={translate('search.filters')} withPadding={false}>
      <Box
        data-testid={TEST_IDS.MOBILE_FILTER_MODAL}
        sx={{ overflow: 'hidden', maxHeight: '80vh', overflowY: 'auto', px: 2 }}
      >
        {renderSearchFilters(onClose)}
        <StyledButton
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ minHeight: '3rem', width: '100%', mt: 4 }}
        >
          {translate('apply')}
        </StyledButton>
      </Box>
    </MobileDetailsModal>
  )
}

export default MobileFilterDetailsModal
